module.exports = ["inherit","initial","unset"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-global-keywords/index.json
// module id = /bB+
// module chunks = 1